<script>
    import BaseAnimation from '../BaseAnimation';

    const fromToConfigs = {
        right: {
            from: {
                opacity: 0,
                x: -50,
            },
            to: (el, uid) => ({
                opacity: 1,
                x: 0,
                scrollTrigger: {
                    trigger: el,
                    id: `${ uid }-right`,
                    start: 'top 90%',
                },
            }),
        },
        middle: {
            from: {
                opacity: 0,
            },
            to: (el, uid) => ({
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    id: `${ uid }-middle`,
                    start: 'top 90%',
                },
            }),
        },
        left: {
            from: {
                opacity: 0,
                x: 50,
            },
            to: (el, uid) => ({
                opacity: 1,
                x: 0,
                scrollTrigger: {
                    trigger: el,
                    id: `${ uid }-left`,
                    start: 'top 90%',
                },
            }),
        },
    };

    export default {
        name: 'fade-inwards-animation',

        mixins: [BaseAnimation],

        props: {
            elements: {
                type: Array,
                required: true,
            },
        },

        beforeDestroy() {
            if (this.motionAccepted) {
                this.scrollTrigger.getById(`${ this.uid }-right`).kill();
                this.scrollTrigger.getById(`${ this.uid }-middle`).kill();
                this.scrollTrigger.getById(`${ this.uid }-left`).kill();
            }
        },

        methods: {
            /**
             * Set the initial state of the animated element.
             */
            setInitialStates() {
                this.elements.forEach(({ element }) => {
                    let el = element();

                    if (el._isVue) {
                        el = el.$el;
                    }

                    el.style.opacity = 0;
                });
            },

            /**
             * Reveal animation.
             */
            reveal() {
                this.elements.forEach(({ element, direction = 'middle' }) => {
                    let el = element();

                    if (el._isVue) {
                        el = el.$el;
                    }

                    this.gsap.set(el, fromToConfigs[direction].from);

                    this.gsap.fromTo(
                        el,
                        fromToConfigs[direction].from,
                        fromToConfigs[direction].to(el, this.uid),
                    );
                });
            },
        },
    };
</script>
